export default {
	props:{
		formTitle:{type:String, default(){ return this.$t('getMyBookingForm.formTitle');} },
		email:{type: String, default: ''},
		bookingCode:{type: String, default: ''},
		googleReCaptchaV3SiteKey:{type:String, default: ''},
	},
	data(){
		return {
			formData: {booking_code:'', email:''},
			formErrors: {},
		}
	},
	watch: {
		email:{
			immediate: true,
			handler(val){
				this.$set(this.formData, 'email', val);
			},
		},
		bookingCode:{
			immediate: true,
			handler(val){
				this.$set(this.formData, 'booking_code', val);
			},
		},
		"formData.email":{
			handler(val){
				this.$emit('update:email', val);
			},
		},
		"formData.booking_code":{
			handler(val){
				this.$emit('update:bookingCode', val);
			},
		},
	},
	computed:{
		actionName(){
			return 'getMyBooking';
		},
		actionUrl(){
			const url = new URL(window.location.href);
			url.searchParams.set('action', this.actionName);
			return url.href;
		},
	},
	methods: {
		async onFormSubmit(event){
			this.$refs.qForm.classList.add('submitting');
			this.formErrors = {};
			const formData = Object.assign({}, this.formData);

			if(this.googleReCaptchaV3SiteKey){
				formData.grc_token = await this.$refs.googleReCaptchaV3.generateRecaptchaToken(this.actionName);
			}

			doFetch(this.actionUrl, {}, {'formData':formData})
				.then((res) => {
					if (!res || !res.success){
						this.formErrors = res.errors ? res.errors : {'main':'Unknown error!'};
						return;
					}
					window.location.href = res.success_url;//redirect
				})
				.catch((error)=>{
					//error
					alert('Unknown error!');
				})
				.finally(()=>{
					this.$refs.qForm.classList.remove('submitting');
				});
		},
	},
	template: `
<form ref="qForm" class="get-my-booking-form client-form" @submit.prevent="onFormSubmit">
	<div v-if="formTitle" class="form-top">{{formTitle}}</div>
  <div class="form-content">
		<qit-input-text class="v1" 
			 type="email" 
			 :label="$t('getMyBookingForm.clientEmail')"
			 :floating-label="true"
			 v-model="formData.email" 
			 :error-msg="formErrors.email"
		></qit-input-text>
		<qit-input-text class="v1" 
			 :label="$t('getMyBookingForm.bookingCode')"
			 :floating-label="true"
			 v-model="formData.booking_code" 
			 :error-msg="formErrors.booking_code"
		></qit-input-text>
	</div>
	<div class="form-bottom">
		<button class="btn text-transform-none button fill" name="btnSubmit" :value="actionName" v-t="'getMyBookingForm.btnShowMyBooking'"></button>
	</div>
  <div v-if="formErrors.main" class="form-msg errors" v-t="formErrors.main"></div>

  <qit-google-recaptcha-v3 ref="googleReCaptchaV3" v-if="googleReCaptchaV3SiteKey" :site-key="googleReCaptchaV3SiteKey"></qit-google-recaptcha-v3>

  <div class="form-submitting-overlay"><div class="spin-loader"></div></div>
</form>
`,
}